try{self['workbox:routing:4.3.1']&&_()}catch(e){}// eslint-disable-line